import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Text from "../../../design-system/primitives/components/Text/Text";
import Tabs from "../../../design-system/primitives/components/Tabs/Tabs";
import PageShell from "../../../design-system/components/PageShell/PageShell";
import { ROUTES } from "../../../routes.js";
import { MODELS, useModel } from "../../../api";
import styles from "./HandbookOverview.css";
import HandbookDocuments from "./HandbookDocuments";
import HandbookFaq from "./HandbookFaq";
import HandbookVideos from "./HandbookVideos";
import HandbookWelcome from "./HandbookWelcome";

const HandbookOverview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handbook = useModel(MODELS.HANDBOOK);
  const [section, setSection] = useState("welcome");
  const [checked, setChecked] = useState<Record<string, boolean>>({});

  const tabs = [
    {
      label: "Hallo!",
      value: "welcome",
      content: (
        <HandbookWelcome
          onShowDocuments={() => setSection("documents")}
          checklist={handbook.checklist}
          checked={checked}
          onCheckedChange={(item, value) =>
            setChecked((current) => ({ ...current, [item]: value }))
          }
        />
      ),
    },
    { label: "FAQ", value: "faq", content: <HandbookFaq faq={handbook.faq} /> },
    {
      label: "Videos",
      value: "videos",
      content: <HandbookVideos videos={handbook.videos} />,
    },
    {
      label: "Dokumente",
      value: "documents",
      content: (
        <HandbookDocuments
          guides={handbook.guides}
          moderationPlans={handbook.moderationPlans}
        />
      ),
    },
  ];

  return (
    <div className={styles.page}>
      <Tabs.Root value={section} onValueChange={setSection}>
        <PageShell
          surface="dark"
          titleButton={{
            icon: "arrow-left",
            ariaLabel: "Zurück",
            onClick: () =>
              void (location.key === "default"
                ? navigate(ROUTES.lernreisenOverview.getUrl())
                : navigate(-1)),
          }}
          titleSlot={
            <div className={styles.headerRow}>
              <Text variant="h4">Handbuch</Text>

              <div className={styles.tabs}>
                <Tabs.List tabs={tabs} ariaLabel="Handbuch-Bereich auswählen" />
              </div>
            </div>
          }
        >
          {tabs.map((tab) => (
            <Tabs.Content key={tab.value} value={tab.value}>
              {tab.content}
            </Tabs.Content>
          ))}
        </PageShell>
      </Tabs.Root>
    </div>
  );
};

export default HandbookOverview;
